import React from 'react'
import PropTypes from 'prop-types'
import BlockContent from '../shared/blockContent'

import './singleColFeature.css'

const SingleColFeature = ({ data }) => {
  const config = {
    bgColor: data.config && data.config.bgColor ? data.config.bgColor : 'black',
    textColor: data.config && data.config.textColor ? data.config.textColor : 'white',
    textAlign: data.config && data.config.textAlign ? data.config.textAlign : 'left',
    wide: data.config && data.config.wide ? 'wide' : '',
  }
  return (
    <section
      className={`singleColFeature bg-${config.bgColor} text-${config.textColor} text-${config.textAlign} ${config.wide}`}
    >
      <div className="content">
        <BlockContent input={data.content}></BlockContent>
      </div>
    </section>
  )
}

SingleColFeature.propTypes = {
  data: PropTypes.object,
}

SingleColFeature.defaultProps = {
  data: {
    config: {
      bgColor: 'black',
      textColor: 'white',
      textAlign: 'left',
    },
  },
}

export default SingleColFeature
